
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";
import { BulkInventoryItemListItem } from "@/models/api/barcodeSystem/inventory/bulkInventoryItems";

const inventoryModuleState = getModule(InventoryModule);

import draggable from "vuedraggable";

import RightClickMenu from "@/components/widgets/RightClickMenu.vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({
  components: {
    RightClickMenu,
    draggable
  }
})
export default class BulkInventorySummaryTable extends Vue {
  @Prop({ default: "table" })
  public id: string;

  @Prop({ default: "" })
  public containerClass: string;

  @Prop({ default: null })
  public tableField: Array<any>;

  @Prop({ default: null })
  public tableMenuItem: Array<any>;

  public rightClickLocation: any = null;
  public showHelp: boolean = false;
  public draggingData: boolean = false;

  get filterFields() {
    let filterFields = this.tableField.filter(
      field => field.hidden === false && field.key !== "selected"
    );
    return filterFields;
  }

  set filterFields(newValue) {
    this.$emit("updateFields", newValue);
  }

  get bulkInventoryItems(): Array<BulkInventoryItemListItem> {
    return inventoryModuleState.bulkData;
  }

  get loading(): boolean {
    return inventoryModuleState.loading;
  }

  get selectedItemCount(): number {
    return inventoryModuleState.getSelectedBulkItemCount;
  }

  get selectedItems(): Array<any> {
    return inventoryModuleState.getSelectedBulkItems;
  }

  
  get totalItems() {
    if (inventoryModuleState.bulkPageData) {
      const items = inventoryModuleState.bulkPageData.totalItems;
      return items ? items : 0;
    } else {
      return 0;
    }
  }

  
  get currentSortAscending() {
    return inventoryModuleState.bulkDataSortAscending;
  }
  get currentSort() {
    return inventoryModuleState.bulkDataSortKey;
  }

  unselectAll() {
    let summaryItems = this.selectedItems;

    summaryItems.forEach(summary => {
      inventoryModuleState.switchBulkItemSelectionStatus(summary.id);
    });
  }

  getComponentData(rowData) {
    return {
      on: {
        click: () => this.onRowClick(rowData),
        contextmenu: $event => this.onRightClicked(rowData, $event),
        dblclick: () => this.onDoubleClicked(rowData)
      }
    };
  }
  canMove() {
    return false;
  }
  putFeature() {
    return false;
  }
  sort(s) {
    this.$emit("sort", s);
  }

  onRightClicked(rowData, event) {
    event.preventDefault();
    if (!rowData.selected) inventoryModuleState.switchBulkItemSelectionStatus(rowData.id);

    this.rightClickLocation = { x: event.x, y: event.y };
  }
  onDoubleClicked(data) {
    inventoryModuleState.viewBulkInventoryItemShortcutAction({selectedItems: [data]});
  }
  onRowClick(rowData) {
    inventoryModuleState.switchBulkItemSelectionStatus(rowData.id);

    this.clearRightClick();
  }
  clearRightClick() {
    this.rightClickLocation = null;
    this.draggingData = false;
  }
  clickMenu(item) {
    let items = this.selectedItems;
    this.$store.dispatch(item.action, { selectedItems: items });
    this.clearRightClick();
  }
  onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
    if (
      Math.ceil(scrollTop) + 1 + clientHeight >= scrollHeight &&
      !this.loading &&
      inventoryModuleState.bulkPageData.totalItems > this.bulkInventoryItems.length
    ) {
      this.$emit("loadMoreData");
    }
  }

  getFieldClass(field, itemData) {
    var fieldClass = null;
    if (field.textAlign) {
      switch (field.textAlign) {
        case "right":
          fieldClass = "text-right";
          break;
        case "left":
          fieldClass = "text-left";
          break;
        case "center":
          fieldClass = "text-center";
          break;
        default:
          break;
      }
    }

    if(field.noWrap)
    {
      fieldClass += " text-nowrap";
    }

    return fieldClass;
  }

  getValue(object, path) {
    if (!path) return;
    return path.split(".").reduce((r, k) => (r ? r[k] : ""), object);
  }
}
